import { InjectionToken } from '@angular/core';

/**
 * Cabecera Cookie de la petición HTTP, inyectada por server.ts en el render SSR.
 * Permite decidir en servidor lo mismo que el navegador decidiría con sus cookies
 * (p. ej. si el usuario ya consintió y el banner de cookies no debe renderizarse),
 * manteniendo el HTML del servidor idéntico al primer render del cliente.
 * En navegador no se provee (null): ahí se lee document.cookie directamente.
 */
export const REQUEST_COOKIES = new InjectionToken<string>('REQUEST_COOKIES');
